export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const SET_LOADER_MESSAGE = 'SET_LOADER_MESSAGE'
export const SET_LOADER_VARIANT = 'SET_LOADER_VARIANT'
